// extracted by mini-css-extract-plugin
export default {"container":"cw7fz1e1a","tableWrap":"chw8g5b8l","characteristicsTable":"cqnjlmhl2","Plan":"cvzjhujup"};